import * as React from "react";
import { Link } from "gatsby";
import { useEffect } from "react";
import "../scss/Register.scss";
import { HeaderStore } from "../store/Header";
import useDocTitle from "../hooks/useDocTitle";
import Header from "../components/HeaderWhite";
import Footer from "../components/Footer";

import { triggerHubspotCTA } from "../hooks/triggerHubspotCTA";

import imgInvestHeader from "../media/images/invest/invest-header.jpg";
import imgMasterplan from "../media/images/invest/masterplan_2_V2.jpg";
import imgInvestorBenefits from "../media/images/invest/investor-benefits.jpg";
import imgPropertyAsset from "../media/images/invest/property-asset.jpg";
import imgInvest from "../media/images/invest/invest.jpg";
import imgHowToInvest from "../media/images/invest/how-to-invest.jpg";

function Register() {
  // Check if the disclaimer should be shown.
  let showDisclaimer =
    typeof window !== "undefined" &&
    window &&
    window.sessionStorage.getItem("showDisclaimer");
  var elDisclaimerStatus = false;
  if (!showDisclaimer) {
    elDisclaimerStatus = true;
  }

  // Click handler for the acknowledge button.
  function handleAcknowledge(e) {
    e.preventDefault();
    document
      .querySelector("#disclaimer-register")
      .classList.remove("display--open");
    typeof window !== "undefined" &&
      window &&
      window.sessionStorage.setItem("showDisclaimer", false);
    document.body.setAttribute("class", "register");
  }

  // Initial page setup
  useDocTitle("Invest");
  useEffect(() => {
    if (typeof window !== "undefined" && window) {
      window.scrollTo(0, 0);
    }
    document.body.setAttribute("class", "register");

    // Lock the body from scrolling.
    if (elDisclaimerStatus) {
      document.body.setAttribute("class", "register scroll-lock");
    }
    HeaderStore.update((s) => {
      s.home = "";
      s.lodge = "";
      s.wave = "";
      s.invest = "active";
      s.team = "";
    });
  }, []);

  return (
    <div className="Register invest-page invest-245-update cream scrollsnap-container-off">
      <Header position="fixed" />
      <div className="register-header">
        <img src={imgInvestHeader} alt="" />
      </div>
      <div className="flex-center padding-50 pull-up-content">
        <div className="container light flex-column items-center">
          <div className="header-section">
            <h1 className="title">
            Capital Committments<br></br>Completed
            </h1>
            <p>Final investment positions still available from $30,000</p>
            <div className="cta-buttons">
              <a
                onClick={(e) => triggerHubspotCTA(e, "invest-start")}
                className="button"
              >
                <span>Invest today</span>
              </a>
              {/* <a
                href={`/pdf/wisemans.zip`}
                onClick={(e) => triggerHubspotCTA(e, "download-PDS-invest")}
                className="button faded"
                download
              >
                <span>Download PDS&nbsp;and&nbsp;TMD</span>
              </a> */}
            </div>
          </div>

          <div className="body-content">
            <div className="section-1">
              <div className="invest-image-container">
                <img src={imgMasterplan} alt="" />
              </div>
              <p className="invest-first-para">
                The Wisemans Surf Lodge Property Trust is an Australian unit
                trust that operates as a registered managed investment scheme
                (the Fund). The Fund will acquire freehold land and resort
                facilities located in Wisemans Ferry, New South Wales and will
                enter into a development management agreement relating to the
                design and construction of the Wisemans Surf Lodge, a world
                class wave pool and associated resort facilities.
              </p>
              <p>
                Investment in the Fund will be held in trust until all capital
                is raised and construction condition precedents are satisfied.
                In the event that the capital raise is unsuccessful, all money
                invested in the Fund will be returned to investors.
              </p>
              <p>
                On completion of the development, the Fund will enter into a
                lease with Balnce to operate the Wisemans Surf Lodge. Balnce
                will pay rent to the Fund and generate a return to the
                Investors. Balnce will operate a member-based revenue model with
                ancillary income from private, corporate events, rent from
                Harvest Group providing food and beverage, and other
                revenue-generating amenities across the site.
              </p>
            </div>

            <div className="section-2">
              <div className="col content">
                <h3>
                  Investor <br></br>benefits include:
                </h3>
                <ul>
                  <li>Targeting distributions of 5.8% (yr. 1 - 10% excluding rent abatement), 12.2% (yr.2), 13% (yr. 3)</li>
                  <li>
                    Monthly income distributions
                  </li>
                  <li>
                    Access to a property investment in the hospitality and
                    leisure sector, with multiple income streams
                  </li>
                  <li>
                    Investment in a 45-acre landholding with 615m of river
                    frontage and future development potential
                  </li>
                  <li>Potential for capital growth</li>
                  <li>
                    A preferential offer from Balnce to be a member of Wisemans
                    Surf Lodge
                  </li>
                </ul>
              </div>
              <div className="col image-wrapper">
                <img
                  className="invest-img gs_reveal"
                  src={imgInvestorBenefits}
                />
              </div>
            </div>

            <div className="section-3">
              <h3>Fund highlights</h3>

              <div className="table">
                <div className="col">
                  <div className="cell">
                    <p className="title">Minimum investment</p>
                    <div className="value">$30,000</div>
                  </div>
                  <div className="cell">
                    <p className="title">
                      Minimum term from fund capitalisation date
                    </p>
                    <div className="value">18 months</div>
                  </div>
                  <div className="cell">
                    <p className="title">Capital raise target</p>
                    <div className="value">$118 million</div>
                  </div>
                </div>
                <div className="col">
                  <div className="cell">
                    <p className="title">Forecast annual yield</p>
                    <div className="value">5.8% (yr. 1) - 13% (yr. 3)</div>
                  </div>
                  <div className="cell">
                    <p className="title">Governance and security structure</p>
                    <div className="value">Managed investment scheme</div>
                  </div>
                  <div className="cell">
                    <p className="title">Co-investment from BALNCE</p>
                    <div className="value">Up to $10 million</div>
                  </div>
                </div>
                <div className="col">
                  <div className="cell">
                    <p className="title">Distribution frequency</p>
                    <div className="value">Monthly</div>
                  </div>
                  <div className="cell">
                    <p className="title">Investor eligibility </p>
                    <div className="value">Wholesale &amp; retail</div>
                  </div>
                  <div className="cell">
                    <p className="title">Operator's Offer</p>
                    <div className="value">Exclusive Membership</div>
                  </div>
                </div>
              </div>

              <div className="cta-buttons">
                <a
                  onClick={(e) => triggerHubspotCTA(e, "invest-start")}
                  className="button"
                >
                  <span>Invest today</span>
                </a>
                {/* <a
                  href={`/pdf/wisemans.zip`}
                  onClick={(e) => triggerHubspotCTA(e, "download-PDS-invest")}
                  className="button faded"
                  download
                >
                  <span>Download PDS&nbsp;and&nbsp;TMD</span>
                </a> */}
              </div>
            </div>

            <div className="section-4">
              <h3>About the property asset.</h3>
              <p>
                The property is located at 5564 Old Northern Road, Wisemans
                Ferry, New South Wales 2775 and comprises the Wisemans Retreat,
                including 54-room accommodation, conference centre, licensed
                restaurant and the Wisemans Ferry Golf Club. This 45-acre site
                is an irregular shape site with approximately 605 metres of
                river frontage, in addition to approximately 400 metres of
                frontage to Old Northern Road. The landholding includes two
                adjoining residential blocks at 5552 and 5554 Old Northern Road.
              </p>
              <img className="invest-img gs_reveal" src={imgPropertyAsset} />
            </div>

            <div className="section-5">
              <div className="top">
                <h3>Development</h3>
                <p>
                  Upon completion of the development, the Fund will own the
                  following high-quality assets:
                </p>
              </div>
              <div className="col image-wrapper">
                <img className="invest-img gs_reveal" src={imgInvest} />
              </div>
              <div className="col content">
                <ul>
                  <li>A 45-acre waterfront land holding</li>
                  <li>A 14,100 sq/m wave pool with Endless Surf wave technology</li>
                  <li>
                    Refurbished 54-room hotel, conference centre, licensed
                    restaurant, bar
                  </li>
                  <li>
                    Gym, plunge pool, spas, alfresco areas and landscaped
                    gardens
                  </li>
                  <li>Boat ramp</li>
                  <li>Golf course</li>
                  <li>
                    Kids playground and BBQ facilities
                  </li>
                  <li>Experiential food system gardens</li>
                </ul>
              </div>
            </div>

            <div className="section-6">
              <div className="col content">
                <h3>How to invest</h3>
                <p>
                  <strong>Step one: </strong>Download the Product Disclosure
                  Statement and Target Market Determination
                </p>
                <p>
                  <strong>Step two: </strong>Determine investment vehicle:
                  individual, business or trust
                </p>
                <p>
                  <strong>Step three: </strong>Complete the online application
                  form
                </p>
                <p>
                  <strong>Step four: </strong>Submit application form and any
                  required identification
                </p>
                <p>
                  <strong>Step five: </strong>Follow email instructions to
                  complete transaction
                </p>
                <div className="cta-wrapper cta-buttons">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://wisemans.setmore.com/"
                    onClick={(e) => triggerHubspotCTA(e, "schedule-a-call")}
                    className="button"
                  >
                    <span>Schedule a call</span>
                  </a>
                  {/* <a
                    href={`/pdf/wisemans.pdf`}
                    onClick={(e) => triggerHubspotCTA(e, "download-PDS-invest")}
                    className="button faded"
                    download
                  >
                    <span>Download PDS&nbsp;and&nbsp;TMD</span>
                  </a> */}
                </div>
              </div>
              <div className="col image-wrapper">
                <img className="invest-img gs_reveal" src={imgHowToInvest} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <div
        id="disclaimer-register"
        className={`modal-container ${
          elDisclaimerStatus ? "display--open" : ""
        }`}
      >
        <div className="modal-content">
          <h3>Disclaimer</h3>
          <p>
            Any information or advice contained on this website is general in
            nature and has been prepared without taking into account your
            objectives, financial situation or needs. Before acting on any
            information or advice on this website, you should consider the
            appropriateness of it (and any relevant product) having regard to
            your circumstances and, if a current offer document and Target
            Market Determination (TMD) document are is available, read these
            offer documents before acquiring products named on this website. You
            should also seek independent financial advice prior to acquiring a
            financial product.
          </p>
          <div className="button-wrapper">
            <a className="button" onClick={handleAcknowledge}>
              Acknowledge
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
